import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LoginService } from '../login.service'
import { SharedService } from 'src/app/shared/shared.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-site-admin-login',
    templateUrl: './site-admin-login.component.html',
    styleUrls: ['./site-admin-login.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SiteAdminLoginComponent implements OnInit {
    loginForm: FormGroup;
    loginError: string = "";
    apiCalling: boolean = false;

    get formDisabled() {
        return this.apiCalling || this.loginForm.invalid;
    }

    constructor(private service: LoginService,
        private sharedService: SharedService,
        private formBuilder: FormBuilder) {
    }

    ngOnInit(): void {
        this.buildForm();
    }

    buildForm() {
        this.loginForm = this.formBuilder.group({
            UserName: ['', Validators.required],
            Password: ['', Validators.required]
        })
    }

    getErrorMsg(control) {
        if (!this.loginForm.get(control).touched) {
            return null;
        }
        const error = this.loginForm.controls[control].errors;
        return "";
    }


    loginUser() {
        if (this.loginForm.invalid) {
            this.loginError = "Inserisci i dettagli di accesso";
        }
        if (this.formDisabled) {
            return;
        }
        this.apiCalling = true;
        let payload = this.loginForm.getRawValue();
        this.service.loginSiteAdmin(payload).subscribe({
            next: (res) => {
                this.apiCalling = false;
                this.sharedService.setAuthDetail(res);
                this.sharedService.navigateToUrl(`/landing`);
            },
            error: (err) => {
                this.apiCalling = false;
                this.loginError = err;
            }
        })
    }
}
